import React from "react";
import cn from "classnames";

export const Button = ({ type = "button", variant, disabled, children, className, ...props }) => {
  return (
    <button
      {...props}
      type={type}
      disabled={disabled}
      className={cn(
        "py-4 px-6 rounded-[48px] inline-block transition-all bg-primary-500 text-center",
        className,
        {
          "text-white hover:outline-primary-100 hover:bg-primary-800 hover:text-white":
            variant !== "secondary",
          "bg-white text-primary-500 outline outline-2 outline-offset-[-2px] outline-primary-500 hover:outline-primary-100 hover:bg-primary-100 hover:text-primary-600":
            variant === "secondary",
          "opacity-[50%] !bg-gray-modern-500 !hover:bg-gray-modern-500 outline-gray-modern-500 text-white hover:text-white cursor-not-allowed	":
            disabled,
        }
      )}
    >
      <span className="text-text-sm font-medium text-current">{children}</span>
    </button>
  );
};
